var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0681 13.6349C10.9473 13.6228 10.8023 13.6228 10.6693 13.6349C7.79352 13.5382 5.50977 11.182 5.50977 8.28199C5.50977 5.32158 7.90227 2.91699 10.8748 2.91699C13.8352 2.91699 16.2398 5.32158 16.2398 8.28199C16.2277 11.182 13.9439 13.5382 11.0681 13.6349Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.829 5.33301C22.1731 5.33301 24.0581 7.23009 24.0581 9.56217C24.0581 11.8459 22.2456 13.7068 19.986 13.7913C19.8894 13.7793 19.7806 13.7793 19.6719 13.7913",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02711 18.093C2.10294 20.0505 2.10294 23.2405 5.02711 25.1859C8.35003 27.4093 13.7996 27.4093 17.1225 25.1859C20.0467 23.2284 20.0467 20.0384 17.1225 18.093C13.8117 15.8818 8.36211 15.8818 5.02711 18.093Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1611 24.667C23.0311 24.4857 23.8528 24.1353 24.5295 23.6157C26.4145 22.202 26.4145 19.8699 24.5295 18.4562C23.8649 17.9487 23.0553 17.6103 22.1974 17.417",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIcon);
export default __webpack_public_path__ + "static/media/teamsIcon.8c4ae1ad9360f6bcbd8fb2e84d46409e.svg";
export { ForwardRef as ReactComponent };